import { roleToRouteMap } from 'app/components/AuthRouter/authRoutes';
import { rolesEnum } from 'app/components/AuthRouter/data/type';
import userApiService from 'app/apiService/user/userApiService';

/**
 * Gets the auth header from localStorage.
 *
 * @return {object} Returns an object with header if logged in.
 */
export function header(shouldRedirect: boolean = true) {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem('user_token') || '{}');

  // Todo : Cleanup
  if (!user && shouldRedirect) {
    resetAndLogin();
  }

  if (user && user.accesstoken) {
    return user.accesstoken;
  }

  return '';
}

export function getUUIDToken() {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem('user_token') || '{}');

  // Todo : Cleanup
  if (!user) {
    localStorage.clear();
    clearCacheData();
    clearCookieData();
    window.location.href = '/login';
  }

  const uuidToken = `cb7e6bff-20b7-47c1-b731-fc494c9a0a1a`;

  if (user) {
    return uuidToken;
  }

  return '';
}

export function isAuthenticated(shouldRedirect: boolean = true) {
  return !!header(shouldRedirect);
}

export const hasRoles = () => {
  const user = JSON.parse(localStorage.getItem('user_token') || '{}');

  if (!user) {
    return resetAndLogin();
  }

  const userRoles = user.roles || '';
  // const isSuperUser = userRoles.find(item => item === rolesEnum.superUser);

  if (userRoles === rolesEnum.salesUser || userRoles === rolesEnum.salesPerson)
    return false;

  return true;
};

/**
 * Gets the user profile from localStorage.
 *
 * @return {object} Returns an object with user profile if logged in.
 */
export function userProfile(shouldRedirect: boolean = true) {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem('user_token') || `{}`);

  // Todo : Cleanup
  if (!Object.keys(user).length && shouldRedirect) {
    resetAndLogin();
  }

  return user;
}
function hasScope(requiredScope) {
  const user = JSON.parse(localStorage.getItem('user_token') || '{}');
  const userScopes = user.scopes || [];
  if (!Array.isArray(userScopes)) return false;

  return userScopes.includes(requiredScope);
}
export const isAllowedToViewActivityMetrics = () => {
  return hasScope('view:activity_metrics');
};

export const validateEmail = inputText => {
  if (!inputText) return false;

  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputText)) {
    return true;
  }

  return false;
};

export const clearCacheData = () => {
  try {
    // Clear service worker caches
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
    
    // Clear sessionStorage items that might cause stale data
    sessionStorage.removeItem('cache_cleared');
    
    // Force fresh fetch for all subsequent requests
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
          registration.update();
        }
      });
    }
  } catch (error) {
    console.log('no cache');
  }
};

export const clearCookieData = () => {
  document.cookie.split(';').forEach(c => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
};

export const checkRole = (userRoles, pageRoles) => {
  try {
    let hasAccess = false;
    userRoles?.map(role => {
      if (pageRoles.includes(role)) {
        hasAccess = true;
      }
    });

    return hasAccess;
  } catch (error) {
    console.log(error);
  }
};

export const getRoleBasedHomePage = () => {
  try {
    const user = userProfile();
    const prioritizedRoles = [
      rolesEnum.betaPerformanceManager,
      rolesEnum.superAdmin,
      rolesEnum.superUser,
      rolesEnum.dealershipGroupExecutive,
      rolesEnum.dealershipExecutive,
      rolesEnum.techUser,
      rolesEnum.salesUser,
      rolesEnum.salesPerson,
      rolesEnum.performanceManager,
      'user',
    ]; // Define role priorities
    let { roles } = user;
    let homepage = null;

    for (const role of prioritizedRoles) {
      if (roles.includes(role)) {
        homepage = roleToRouteMap[role];
        break;
      }
    }
    // Return default homepage if no role matches
    return homepage || '/dashboard';
  } catch (error) {
    console.log(error);
    return '/dashboard'; // Return default homepage in case of error
  }
};

export const getRoutes = () => {
  try {
    const user = JSON.parse(
      `${window.localStorage.getItem('user_token')}` || `{}`,
    );

    let routes = user?.resource_mappings || [];

    if (routes?.length) {
      return routes;
    } else {
      // resetAndLogin();
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

export const getGroupDashboardURL = () => {
  try {
    const user = JSON.parse(
      `${window.localStorage.getItem('user_token')}` || `{}`,
    );

    let dealerGroup = user?.dealer_group || {};
    if (Object.keys(dealerGroup).length) {
      let settings = dealerGroup?.settings || {};

      if (Object.keys(settings).length) {
        let dashboardURL = settings?.business_dashboard_url || '';

        return dashboardURL?.trim()?.length ? dashboardURL : '';
      }
    }
  } catch (error) {
    console.log(error);
    return '';
  }
};

const resetAndLogin = () => {
  try {
    localStorage.clear();
    clearCacheData();
    clearCookieData();
    window.location.href = '/login';
  } catch (error) {
    console.log(error);
  }
};

export const handleLogout = async () => {
  try {
    await userApiService.postLogOutEvent();
    window.localStorage.removeItem('user_token');
    // localStorage.clear()
    ['user_token'].forEach(key => localStorage.removeItem(key));
    clearCacheData();
    // history.push('/login');
    window.location.href = '/login';
  } catch (error) {
    console.log('logout error', error);
    // throw new Error("Logout event log failed");
  } finally {
    window.localStorage.removeItem('user_token');
    // localStorage.clear()
    ['user_token'].forEach(key => localStorage.removeItem(key));
    clearCacheData();
    window.location.href = '/login';
  }
};
